<template>
  <div class="cont">
    <!--<div class="navTitle">当前位置：益书宝页面 > 导出文章 > 导出到知识库</div>-->
    <div class="bgcBox">
      <div class="flexBox">
        <div class="meBox">
          <div class="title">选择预存入知识库的文档</div>
          <div class="listBox">
            <div class="scrollBox">
              <el-tree
                :data="mewz"
                :props="props"
                :check-strictly="true"
                ref="treeMe"
                node-key="id"
                show-checkbox
              >
              </el-tree>
            </div>
          </div>
        </div>
        <div class="jiantouBox">
          <img src="../../../../assets/images/shuangjiantou.png" alt="">
        </div>
        <div class="zskBox">
          <div class="title">选择您要将文档存入的位置</div>
          <div class="listBox">
            <div class="scrollBox">
              <el-tree
                :data="zsgl"
                :props="props"
                ref="treeZsk"
                node-key="id"
                show-checkbox
                :check-strictly="true"
                @check-change="handleCheckChange">
              </el-tree>
            </div>
            <div class="btn" @click="cjWenJ" v-show="kuAddwenJ">
              新建文件夹
            </div>
          </div>
        </div>
      </div>
      <div class="btnBox">
        <div class="daoR" @click="daoR">确定</div>
        <div class="fanhui" @click="toModular('/home/wdwzBanKuai')">返回</div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "daochuBanKuai",
    data() {
      return {
        props: {
          label: 'label',
          children: 'folder_info'
        },
        zsgl: [],  //  知识库树
        mewz: [], //   自己文章列表
        zskid: '',
        count: 1,
        kuAddwenJ: true // 控制在知识库创建文件夹按钮
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      if (!this.user) {
        this.$router.push("/login")
      }
      this.$emit('setIsAct', 6)
      this.getKu()
      this.getmeShu()
    },
    methods: {
      // 获取库和树
      getKu() {
        this.$api.apiAdmin.GetAllFolder({
          mid: this.user.mid
        }).then(res => {
          var ary = res.data
          if(ary.length < 1){
            this.kuAddwenJ = false
            return false
          }else {
            this.kuAddwenJ = true
            ary.map(item => {
              item.label = item.name
            })
            this.zsgl = ary
          }

        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 获取自己文件夹的树
      getmeShu() {
        this.$api.apiAdmin.ApiFolderList({
          mid: this.user.mid
        }).then(res => {
          console.log(res)
          res.data.map(item => {
            item.label = item.foldername
            item.folder_info = item.detail
            item.folder_info.map(items => {
              items.label = items.title
              items.fid = item.id
            })
          })
          this.mewz = res.data
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      resetChecked() {
        this.$refs.treeZsk.setCheckedKeys([]);
      },
      handleCheckChange(data) {
        let arr = this.$refs.treeZsk.getCheckedNodes()
        console.log(arr)
        if (arr.length > 1) {
          this.resetChecked()
          this.$refs.treeZsk.setChecked(data.id, true);
        }
      },

      daoR() {
        var num = true
        var Zskary = this.$refs.treeZsk.getCheckedNodes()
        var Meary = this.$refs.treeMe.getCheckedNodes().concat(this.$refs.treeMe.getHalfCheckedNodes())
        let arr = []
        var sonarr = []

        Meary.map(item => {
          if (item.foldername) {
            num = false
            arr.push(
              {
                "foldername": item.foldername,
                "id":item.id,
                "ids": ""
              },
            )
          }else {
            sonarr.push(item.id)
          }
        })
        Meary.map(item => {
          if (!item.foldername) {
            arr.map(items => {
              if (item.fid === items.id) {
                items.ids += item.id + ","
              }
            })
          }
        })
        arr.map(item =>{
          console.log(item.ids)
          item.ids = item.ids.substring(0,item.ids.length - 1)
        })
        var meStrId = []
        if (!Meary[0]) {
          this.$messageError('请选择你所要导入文章');
          return false
        } else {
          Meary.map(item => {
            if (!item.folder_info) {
              meStrId.push(item.id)
            }
          })
        }
        if (meStrId.length < 1) {
          this.$messageError('请选择文章');
          return false
        }
        if (!Zskary[0]) {
          this.$messageError('请选择你所要存储在知识库的位置');
          return false
        }
        if(num){
          var data = {}
          if (Zskary[0].kid) {
            data = {
              mid: this.user.mid,
              ids: sonarr.join(','),
              folderid: Zskary[0].id,
              kid: Zskary[0].kid,
              username: this.user.mnickname
            }
          } else {
            data = {
              mid: this.user.mid,
              ids: sonarr.join(','),
              folderid: 0,
              kid: Zskary[0].id,
              username: this.user.mnickname
            }
          }

          this.$api.apiAdmin.Export(data).then(res => {
            this.$messageSuccess(res.msg);
            this.$refs.treeZsk.setCheckedKeys([]);
            this.$refs.treeMe.setCheckedKeys([]);
            this.getKu()
            this.getmeShu()
          }).catch(res => {
            this.$messageError(res.msg);
          })
        }else {
          var dataTwo = {}
          if (Zskary[0].kid) {
            dataTwo = {
              mid: this.user.mid,
              data: JSON.stringify(arr),
              folderid: Zskary[0].id,
              kid: Zskary[0].kid,
              username: this.user.mnickname
            }
          } else {
            dataTwo = {
              mid: this.user.mid,
              data: JSON.stringify(arr),
              folderid: 0,
              kid: Zskary[0].id,
              username: this.user.mnickname
            }
          }

          this.$api.apiAdmin.ExportMore(dataTwo).then(res => {
            this.$messageSuccess(res.msg);
            this.$refs.treeZsk.setCheckedKeys([]);
            this.$refs.treeMe.setCheckedKeys([]);
            this.getKu()
            this.getmeShu()
          }).catch(res => {
            this.$messageError(res.msg);
          })
        }

      },
      // 创建文件夹
      cjWenJ() {
        var ary = this.$refs.treeZsk.getCheckedNodes()
        if (!ary[0]) {
          this.$messageError('请选择你所要创建文件夹的位置');
          return false
        }
        this.$prompt('<h3>新建文件夹</h3>', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'cjBtn',
          cancelButtonClass: 'qxBtn',
          center: true,
          dangerouslyUseHTMLString: true,
          roundButton: true,
          inputPattern: /\S/,
          inputErrorMessage: '名字不能为空'
        }).then(({value}) => {
          var data = {}
          if (ary[0].kid) {
            data = {
              mid: this.user.mid,
              title: value,
              parentid: ary[0].id,
              kid: ary[0].kid,
              username: this.user.mnickname
            }
          } else {
            data = {
              mid: this.user.mid,
              title: value,
              parentid: 0,
              kid: ary[0].id,
              username: this.user.mnickname
            }
          }
          this.$api.apiAdmin.ApiAddFolder(data).then(res => {
            this.$messageSuccess(res.msg);
            this.getKu()
          }).catch(res => {
            this.$messageError(res.msg);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },

      toModular(path) {
        this.$router.push(path)
      },

    },
    components: {},
    watch: {
      $route() {
        this.getList()
      }
    }
  }
</script>

<style scoped lang="scss">
  .bgc {
    background: url("../../../../assets/images/xian.png") no-repeat bottom center !important;
    color: #007be5 !important;
  }

  .cont {
    width: 1220px;
    margin: 0 auto;
    padding-bottom: 50px;

    .navTitle {
      width: 100%;
      height: 40px;
      line-height: 40px;
      color: #ffffff;
      font-size: 14px;
    }

    .bgcBox {
      width: 100%;
      min-height: 800px;
      padding: 30px;
      background-color: #fff;

      .flexBox {
        width: 100%;
        display: flex;
        margin-top: 50px;
        justify-content: center;

        .meBox {
          width: 380px;
          min-height: 560px;
          background-color: #ffffff;
          box-shadow: 0px 1px 13px 0px rgba(183, 183, 183, 0.3);
          border-radius: 6px;

          .title {
            width: 100%;
            height: 44px;
            background-color: #0a2240;
            font-size: 16px;
            color: #fff;
            text-align: center;
            line-height: 44px;
            border-top-left-radius: 6px;
            border-top-right-radius: 6px;
          }

          .listBox {
            width: 100%;
            height: 516px;
            overflow: hidden;
            padding: 20px 15px;

            .scrollBox {
              width: 398px;
              padding-right: 20px;
              height: 516px;
              overflow-y: scroll;
            }
          }
        }

        .jiantouBox {
          width: 150px;
          padding-top: 270px;
          text-align: center;

          img {
            width: 50px;
          }
        }

        .zskBox {
          width: 380px;
          min-height: 560px;
          background-color: #ffffff;
          box-shadow: 0px 1px 13px 0px rgba(183, 183, 183, 0.3);
          border-radius: 6px;

          .title {
            width: 100%;
            height: 44px;
            background-color: #0a2240;
            font-size: 16px;
            color: #fff;
            text-align: center;
            line-height: 44px;
            border-top-left-radius: 6px;
            border-top-right-radius: 6px;
          }

          .listBox {
            width: 100%;
            height: 516px;
            overflow: hidden;

            .scrollBox {
              width: 398px;
              padding-right: 20px;
              height: 460px;
              padding: 20px 15px;
              overflow-y: scroll;
            }

            .btn {
              width: 262px;
              height: 40px;
              background-image: linear-gradient(37deg,
                #ffb400 0%,
                #fc7802 100%),
              linear-gradient(
                  #ffca28,
                  #ffca28);
              background-blend-mode: normal,
              normal;
              border-radius: 4px;
              margin-left: 60px;
              margin-top: 4px;
              text-align: center;
              line-height: 40px;
              font-size: 14px;
              color: #fff;
              cursor: pointer;
            }
          }
        }
      }

      .btnBox {
        width: 100%;
        margin-top: 30px;
        display: flex;
        justify-content: center;

        .daoR {
          width: 138px;
          height: 52px;
          background-image: linear-gradient(37deg,
            #ffb400 0%,
            #fc7802 100%),
          linear-gradient(
              #ffca28,
              #ffca28);
          background-blend-mode: normal,
          normal;
          border-radius: 8px;
          text-align: center;
          line-height: 52px;
          color: #ffffff;
          cursor: pointer;
        }

        .fanhui {
          width: 138px;
          height: 52px;
          background-color: #b3bfca;
          border-radius: 8px;
          text-align: center;
          line-height: 52px;
          color: #ffffff;
          margin-left: 30px;
          cursor: pointer;
        }
      }
    }

  }

</style>
